import React from 'react';
import PropTypes from 'prop-types';

const UploadSuccessPanel = (props) => {
  const { documentName } = props;
  const documentNameParts = documentName.split('.');
  const documentExtension = documentNameParts[documentNameParts.length - 1].toLowerCase();

  let documentFileTypeIconSrc;

  switch (documentExtension) {
    case 'pdf':
      documentFileTypeIconSrc = 'images/self-serve-builder/zero-state/pdf-2x.png';
      break;
    case 'doc':
    case 'docx':
      documentFileTypeIconSrc = 'images/self-serve-builder/zero-state/word-2x.png';
      break;
    default:
      documentFileTypeIconSrc = 'images/self-serve-builder/zero-state/doc-2x.png';
      break;
  }

  return (
    <div className="upload-success-panel">
      <p className="upload-success-header">Upload Successful!</p>
      <img
        alt="document file type icon"
        className="document-file-type-icon"
        src={documentFileTypeIconSrc}
      />
      <p className="document-name">{documentName}</p>
      <p className="account-creation-benefits-text">
        Creating an account will allow you to add fillable fields, save, and share your document
      </p>
    </div>
  );
};

UploadSuccessPanel.propTypes = {
  documentName: PropTypes.string.isRequired,
};

export default UploadSuccessPanel;



// WEBPACK FOOTER //
// ./src-react/SelfServeModals/ZeroStateModal/ZeroStateModalNewAccountBody/UploadSuccessPanel.jsx